import { render, staticRenderFns } from "./ContactWay.vue?vue&type=template&id=3c34c21d&scoped=true&"
import script from "./ContactWay.vue?vue&type=script&lang=js&"
export * from "./ContactWay.vue?vue&type=script&lang=js&"
import style0 from "./ContactWay.vue?vue&type=style&index=0&id=3c34c21d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c34c21d",
  null
  
)

export default component.exports